import type { DemoExamsType } from "../demo";
import { proethicaTheme } from "./praxis-proethica";

export const mockedTheme = {
	colors: {
		light: {
			primary: "rgb(0, 102, 132)",
			onPrimary: "rgb(255, 255, 255)",
			primaryContainer: "rgb(190, 233, 255)",
			onPrimaryContainer: "rgb(0, 31, 42)",
			secondary: "rgb(0, 104, 116)",
			onSecondary: "rgb(255, 255, 255)",
			secondaryContainer: "rgb(131, 220, 235)",
			onSecondaryContainer: "rgb(0, 31, 36)",
			tertiary: "rgb(93, 91, 125)",
			onTertiary: "rgb(255, 255, 255)",
			tertiaryContainer: "rgb(227, 223, 255)",
			onTertiaryContainer: "rgb(26, 24, 54)",
			error: "rgb(186, 26, 26)",
			onError: "rgb(255, 255, 255)",
			errorContainer: "rgb(255, 218, 214)",
			onErrorContainer: "rgb(65, 0, 2)",
			background: "rgb(251, 252, 254)",
			onBackground: "rgb(25, 28, 30)",
			surface: "rgb(251, 252, 254)",
			onSurface: "rgb(25, 28, 30)",
			surfaceVariant: "rgb(220, 228, 233)",
			onSurfaceVariant: "rgb(64, 72, 76)",
			outline: "rgb(112, 120, 125)",
			outlineVariant: "rgb(192, 200, 205)",
			shadow: "rgb(0, 0, 0)",
			scrim: "rgb(0, 0, 0)",
			inverseSurface: "rgb(46, 49, 50)",
			inverseOnSurface: "rgb(239, 241, 243)",
			inversePrimary: "rgb(104, 211, 255)",
			elevation: {
				level0: "transparent",
				level1: "rgb(238, 245, 248)",
				level2: "rgb(231, 240, 244)",
				level3: "rgb(223, 236, 241)",
				level4: "rgb(221, 234, 239)",
				level5: "rgb(216, 231, 237)",
			},
			surfaceDisabled: "rgba(25, 28, 30, 0.12)",
			onSurfaceDisabled: "rgba(25, 28, 30, 0.38)",
			backdrop: "rgba(42, 49, 54, 0.4)",
		},
		dark: {
			primary: "rgb(104, 211, 255)",
			onPrimary: "rgb(0, 53, 70)",
			primaryContainer: "rgb(0, 77, 100)",
			onPrimaryContainer: "rgb(190, 233, 255)",
			secondary: "rgb(79, 216, 235)",
			onSecondary: "rgb(0, 54, 61)",
			secondaryContainer: "rgb(0, 79, 88)",
			onSecondaryContainer: "rgb(151, 240, 255)",
			tertiary: "rgb(198, 194, 234)",
			onTertiary: "rgb(47, 45, 77)",
			tertiaryContainer: "rgb(69, 67, 100)",
			onTertiaryContainer: "rgb(227, 223, 255)",
			error: "rgb(255, 180, 171)",
			onError: "rgb(105, 0, 5)",
			errorContainer: "rgb(147, 0, 10)",
			onErrorContainer: "rgb(255, 180, 171)",
			background: "rgb(25, 28, 30)",
			onBackground: "rgb(225, 226, 228)",
			surface: "rgb(25, 28, 30)",
			onSurface: "rgb(225, 226, 228)",
			surfaceVariant: "rgb(64, 72, 76)",
			onSurfaceVariant: "rgb(192, 200, 205)",
			outline: "rgb(138, 146, 151)",
			outlineVariant: "rgb(64, 72, 76)",
			shadow: "rgb(0, 0, 0)",
			scrim: "rgb(0, 0, 0)",
			inverseSurface: "rgb(225, 226, 228)",
			inverseOnSurface: "rgb(46, 49, 50)",
			inversePrimary: "rgb(0, 102, 132)",
			elevation: {
				level0: "transparent",
				level1: "rgb(29, 37, 41)",
				level2: "rgb(31, 43, 48)",
				level3: "rgb(34, 48, 55)",
				level4: "rgb(35, 50, 57)",
				level5: "rgb(36, 54, 62)",
			},
			surfaceDisabled: "rgba(225, 226, 228, 0.12)",
			onSurfaceDisabled: "rgba(225, 226, 228, 0.38)",
			backdrop: "rgba(42, 49, 54, 0.4)",
		},
	},
	roundness: 2,
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const demoThemeColors: Record<DemoExamsType, any> = {
	proethica: proethicaTheme,
	mcc: {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(136, 82, 0)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(255, 220, 188)",
				onPrimaryContainer: "rgb(44, 23, 0)",
				secondary: "rgb(0, 104, 116)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(151, 240, 255)",
				onSecondaryContainer: "rgb(0, 31, 36)",
				tertiary: "rgb(86, 99, 59)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(218, 233, 182)",
				onTertiaryContainer: "rgb(21, 31, 1)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(255, 251, 255)",
				onBackground: "rgb(31, 27, 22)",
				surface: "rgb(255, 251, 255)",
				onSurface: "rgb(31, 27, 22)",
				surfaceVariant: "rgb(241, 223, 208)",
				onSurfaceVariant: "rgb(80, 69, 58)",
				outline: "rgb(130, 117, 104)",
				outlineVariant: "rgb(213, 196, 181)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(53, 47, 43)",
				inverseOnSurface: "rgb(250, 239, 231)",
				inversePrimary: "rgb(255, 184, 106)",
				elevation: {
					level0: "transparent",
					level1: "rgb(249, 243, 242)",
					level2: "rgb(246, 238, 235)",
					level3: "rgb(242, 232, 227)",
					level4: "rgb(241, 231, 224)",
					level5: "rgb(238, 227, 219)",
				},
				surfaceDisabled: "rgba(31, 27, 22, 0.12)",
				onSurfaceDisabled: "rgba(31, 27, 22, 0.38)",
				backdrop: "rgba(57, 47, 36, 0.4)",
			},
			dark: {
				primary: "rgb(255, 184, 106)",
				onPrimary: "rgb(73, 41, 0)",
				primaryContainer: "rgb(104, 61, 0)",
				onPrimaryContainer: "rgb(255, 220, 188)",
				secondary: "rgb(79, 216, 235)",
				onSecondary: "rgb(0, 54, 61)",
				secondaryContainer: "rgb(0, 79, 88)",
				onSecondaryContainer: "rgb(151, 240, 255)",
				tertiary: "rgb(190, 204, 156)",
				onTertiary: "rgb(41, 52, 17)",
				tertiaryContainer: "rgb(63, 75, 38)",
				onTertiaryContainer: "rgb(218, 233, 182)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(31, 27, 22)",
				onBackground: "rgb(235, 225, 217)",
				surface: "rgb(31, 27, 22)",
				onSurface: "rgb(235, 225, 217)",
				surfaceVariant: "rgb(80, 69, 58)",
				onSurfaceVariant: "rgb(213, 196, 181)",
				outline: "rgb(157, 142, 129)",
				outlineVariant: "rgb(80, 69, 58)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(235, 225, 217)",
				inverseOnSurface: "rgb(53, 47, 43)",
				inversePrimary: "rgb(136, 82, 0)",
				elevation: {
					level0: "transparent",
					level1: "rgb(42, 35, 26)",
					level2: "rgb(49, 40, 29)",
					level3: "rgb(56, 44, 31)",
					level4: "rgb(58, 46, 32)",
					level5: "rgb(62, 49, 34)",
				},
				surfaceDisabled: "rgba(235, 225, 217, 0.12)",
				onSurfaceDisabled: "rgba(235, 225, 217, 0.38)",
				backdrop: "rgba(57, 46, 36, 0.4)",
			},
		},
	},
	"veterinary-medicine": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(50, 92, 168)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(216, 226, 255)",
				onPrimaryContainer: "rgb(0, 26, 66)",
				secondary: "rgb(0, 102, 137)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(194, 232, 255)",
				onSecondaryContainer: "rgb(0, 30, 44)",
				tertiary: "rgb(40, 94, 167)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(214, 227, 255)",
				onTertiaryContainer: "rgb(0, 27, 61)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(254, 251, 255)",
				onBackground: "rgb(27, 27, 31)",
				surface: "rgb(254, 251, 255)",
				onSurface: "rgb(27, 27, 31)",
				surfaceVariant: "rgb(225, 226, 236)",
				onSurfaceVariant: "rgb(68, 71, 79)",
				outline: "rgb(117, 119, 127)",
				outlineVariant: "rgb(197, 198, 208)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(48, 48, 52)",
				inverseOnSurface: "rgb(242, 240, 244)",
				inversePrimary: "rgb(174, 198, 255)",
				elevation: {
					level0: "transparent",
					level1: "rgb(244, 243, 251)",
					level2: "rgb(238, 238, 248)",
					level3: "rgb(232, 234, 245)",
					level4: "rgb(230, 232, 245)",
					level5: "rgb(225, 229, 243)",
				},
				surfaceDisabled: "rgba(27, 27, 31, 0.12)",
				onSurfaceDisabled: "rgba(27, 27, 31, 0.38)",
				backdrop: "rgba(46, 48, 56, 0.4)",
			},
			dark: {
				primary: "rgb(174, 198, 255)",
				onPrimary: "rgb(0, 46, 106)",
				primaryContainer: "rgb(17, 68, 143)",
				onPrimaryContainer: "rgb(216, 226, 255)",
				secondary: "rgb(120, 209, 255)",
				onSecondary: "rgb(0, 53, 73)",
				secondaryContainer: "rgb(0, 77, 104)",
				onSecondaryContainer: "rgb(194, 232, 255)",
				tertiary: "rgb(169, 199, 255)",
				onTertiary: "rgb(0, 48, 99)",
				tertiaryContainer: "rgb(0, 70, 139)",
				onTertiaryContainer: "rgb(214, 227, 255)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(27, 27, 31)",
				onBackground: "rgb(227, 226, 230)",
				surface: "rgb(27, 27, 31)",
				onSurface: "rgb(227, 226, 230)",
				surfaceVariant: "rgb(68, 71, 79)",
				onSurfaceVariant: "rgb(197, 198, 208)",
				outline: "rgb(142, 144, 153)",
				outlineVariant: "rgb(68, 71, 79)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(227, 226, 230)",
				inverseOnSurface: "rgb(48, 48, 52)",
				inversePrimary: "rgb(50, 92, 168)",
				elevation: {
					level0: "transparent",
					level1: "rgb(34, 36, 42)",
					level2: "rgb(39, 41, 49)",
					level3: "rgb(43, 46, 56)",
					level4: "rgb(45, 48, 58)",
					level5: "rgb(48, 51, 62)",
				},
				surfaceDisabled: "rgba(227, 226, 230, 0.12)",
				onSurfaceDisabled: "rgba(227, 226, 230, 0.38)",
				backdrop: "rgba(46, 48, 56, 0.4)",
			},
		},
	},
	"ai-essentials": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(192, 0, 1)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(255, 218, 212)",
				onPrimaryContainer: "rgb(65, 0, 0)",
				secondary: "rgb(0, 102, 134)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(192, 232, 255)",
				onSecondaryContainer: "rgb(0, 30, 43)",
				tertiary: "rgb(112, 92, 46)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(251, 223, 166)",
				onTertiaryContainer: "rgb(37, 26, 0)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(255, 251, 255)",
				onBackground: "rgb(32, 26, 25)",
				surface: "rgb(255, 251, 255)",
				onSurface: "rgb(32, 26, 25)",
				surfaceVariant: "rgb(245, 221, 218)",
				onSurfaceVariant: "rgb(83, 67, 65)",
				outline: "rgb(133, 115, 112)",
				outlineVariant: "rgb(216, 194, 190)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(54, 47, 46)",
				inverseOnSurface: "rgb(251, 238, 236)",
				inversePrimary: "rgb(255, 180, 168)",
				elevation: {
					level0: "transparent",
					level1: "rgb(252, 238, 242)",
					level2: "rgb(250, 231, 235)",
					level3: "rgb(248, 223, 227)",
					level4: "rgb(247, 221, 225)",
					level5: "rgb(246, 216, 219)",
				},
				surfaceDisabled: "rgba(32, 26, 25, 0.12)",
				onSurfaceDisabled: "rgba(32, 26, 25, 0.38)",
				backdrop: "rgba(59, 45, 43, 0.4)",
			},
			dark: {
				primary: "rgb(255, 180, 168)",
				onPrimary: "rgb(105, 0, 0)",
				primaryContainer: "rgb(147, 0, 0)",
				onPrimaryContainer: "rgb(255, 218, 212)",
				secondary: "rgb(112, 210, 255)",
				onSecondary: "rgb(0, 53, 71)",
				secondaryContainer: "rgb(0, 77, 102)",
				onSecondaryContainer: "rgb(192, 232, 255)",
				tertiary: "rgb(222, 196, 140)",
				onTertiary: "rgb(62, 46, 4)",
				tertiaryContainer: "rgb(86, 68, 25)",
				onTertiaryContainer: "rgb(251, 223, 166)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(32, 26, 25)",
				onBackground: "rgb(237, 224, 221)",
				surface: "rgb(32, 26, 25)",
				onSurface: "rgb(237, 224, 221)",
				surfaceVariant: "rgb(83, 67, 65)",
				onSurfaceVariant: "rgb(216, 194, 190)",
				outline: "rgb(160, 140, 137)",
				outlineVariant: "rgb(83, 67, 65)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(237, 224, 221)",
				inverseOnSurface: "rgb(54, 47, 46)",
				inversePrimary: "rgb(192, 0, 1)",
				elevation: {
					level0: "transparent",
					level1: "rgb(43, 34, 32)",
					level2: "rgb(50, 38, 36)",
					level3: "rgb(57, 43, 41)",
					level4: "rgb(59, 45, 42)",
					level5: "rgb(63, 48, 45)",
				},
				surfaceDisabled: "rgba(237, 224, 221, 0.12)",
				onSurfaceDisabled: "rgba(237, 224, 221, 0.38)",
				backdrop: "rgba(59, 45, 43, 0.4)",
			},
		},
	},
	"genai-engineer": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(191, 10, 0)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(255, 218, 212)",
				onPrimaryContainer: "rgb(64, 1, 0)",
				secondary: "rgb(0, 103, 127)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(183, 234, 255)",
				onSecondaryContainer: "rgb(0, 31, 40)",
				tertiary: "rgb(111, 92, 46)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(251, 224, 166)",
				onTertiaryContainer: "rgb(37, 26, 0)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(255, 251, 255)",
				onBackground: "rgb(32, 26, 25)",
				surface: "rgb(255, 251, 255)",
				onSurface: "rgb(32, 26, 25)",
				surfaceVariant: "rgb(245, 221, 217)",
				onSurfaceVariant: "rgb(83, 67, 65)",
				outline: "rgb(133, 115, 112)",
				outlineVariant: "rgb(216, 194, 190)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(54, 47, 45)",
				inverseOnSurface: "rgb(251, 238, 235)",
				inversePrimary: "rgb(255, 180, 167)",
				elevation: {
					level0: "transparent",
					level1: "rgb(252, 239, 242)",
					level2: "rgb(250, 232, 235)",
					level3: "rgb(248, 225, 227)",
					level4: "rgb(247, 222, 224)",
					level5: "rgb(246, 217, 219)",
				},
				surfaceDisabled: "rgba(32, 26, 25, 0.12)",
				onSurfaceDisabled: "rgba(32, 26, 25, 0.38)",
				backdrop: "rgba(59, 45, 43, 0.4)",
			},
			dark: {
				primary: "rgb(255, 180, 167)",
				onPrimary: "rgb(104, 3, 0)",
				primaryContainer: "rgb(146, 6, 0)",
				onPrimaryContainer: "rgb(255, 218, 212)",
				secondary: "rgb(92, 213, 251)",
				onSecondary: "rgb(0, 53, 67)",
				secondaryContainer: "rgb(0, 78, 96)",
				onSecondaryContainer: "rgb(183, 234, 255)",
				tertiary: "rgb(221, 196, 140)",
				onTertiary: "rgb(62, 46, 4)",
				tertiaryContainer: "rgb(86, 68, 25)",
				onTertiaryContainer: "rgb(251, 224, 166)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(32, 26, 25)",
				onBackground: "rgb(237, 224, 221)",
				surface: "rgb(32, 26, 25)",
				onSurface: "rgb(237, 224, 221)",
				surfaceVariant: "rgb(83, 67, 65)",
				onSurfaceVariant: "rgb(216, 194, 190)",
				outline: "rgb(160, 140, 137)",
				outlineVariant: "rgb(83, 67, 65)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(237, 224, 221)",
				inverseOnSurface: "rgb(54, 47, 45)",
				inversePrimary: "rgb(191, 10, 0)",
				elevation: {
					level0: "transparent",
					level1: "rgb(43, 34, 32)",
					level2: "rgb(50, 38, 36)",
					level3: "rgb(57, 43, 41)",
					level4: "rgb(59, 45, 42)",
					level5: "rgb(63, 48, 45)",
				},
				surfaceDisabled: "rgba(237, 224, 221, 0.12)",
				onSurfaceDisabled: "rgba(237, 224, 221, 0.38)",
				backdrop: "rgba(59, 45, 43, 0.4)",
			},
		},
	},
	"ai-assessment": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(0, 106, 96)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(116, 248, 229)",
				onPrimaryContainer: "rgb(0, 32, 28)",
				secondary: "rgb(74, 99, 95)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(204, 232, 226)",
				onSecondaryContainer: "rgb(5, 32, 28)",
				tertiary: "rgb(69, 97, 121)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(204, 229, 255)",
				onTertiaryContainer: "rgb(0, 30, 49)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(250, 253, 251)",
				onBackground: "rgb(25, 28, 27)",
				surface: "rgb(250, 253, 251)",
				onSurface: "rgb(25, 28, 27)",
				surfaceVariant: "rgb(218, 229, 225)",
				onSurfaceVariant: "rgb(63, 73, 71)",
				outline: "rgb(111, 121, 119)",
				outlineVariant: "rgb(190, 201, 198)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(45, 49, 48)",
				inverseOnSurface: "rgb(239, 241, 239)",
				inversePrimary: "rgb(83, 219, 201)",
				elevation: {
					level0: "transparent",
					level1: "rgb(238, 246, 243)",
					level2: "rgb(230, 241, 239)",
					level3: "rgb(223, 237, 234)",
					level4: "rgb(220, 235, 232)",
					level5: "rgb(215, 232, 229)",
				},
				surfaceDisabled: "rgba(25, 28, 27, 0.12)",
				onSurfaceDisabled: "rgba(25, 28, 27, 0.38)",
				backdrop: "rgba(41, 50, 48, 0.4)",
			},
			dark: {
				primary: "rgb(83, 219, 201)",
				onPrimary: "rgb(0, 55, 49)",
				primaryContainer: "rgb(0, 80, 72)",
				onPrimaryContainer: "rgb(116, 248, 229)",
				secondary: "rgb(177, 204, 198)",
				onSecondary: "rgb(28, 53, 49)",
				secondaryContainer: "rgb(51, 75, 71)",
				onSecondaryContainer: "rgb(204, 232, 226)",
				tertiary: "rgb(173, 202, 230)",
				onTertiary: "rgb(21, 51, 73)",
				tertiaryContainer: "rgb(45, 73, 97)",
				onTertiaryContainer: "rgb(204, 229, 255)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(25, 28, 27)",
				onBackground: "rgb(224, 227, 225)",
				surface: "rgb(25, 28, 27)",
				onSurface: "rgb(224, 227, 225)",
				surfaceVariant: "rgb(63, 73, 71)",
				onSurfaceVariant: "rgb(190, 201, 198)",
				outline: "rgb(137, 147, 144)",
				outlineVariant: "rgb(63, 73, 71)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(224, 227, 225)",
				inverseOnSurface: "rgb(45, 49, 48)",
				inversePrimary: "rgb(0, 106, 96)",
				elevation: {
					level0: "transparent",
					level1: "rgb(28, 38, 36)",
					level2: "rgb(30, 43, 41)",
					level3: "rgb(31, 49, 46)",
					level4: "rgb(32, 51, 48)",
					level5: "rgb(33, 55, 51)",
				},
				surfaceDisabled: "rgba(224, 227, 225, 0.12)",
				onSurfaceDisabled: "rgba(224, 227, 225, 0.38)",
				backdrop: "rgba(41, 50, 48, 0.4)",
			},
		},
	},
	"healthcare-1": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(104, 71, 192)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(232, 221, 255)",
				onPrimaryContainer: "rgb(33, 0, 93)",
				secondary: "rgb(97, 91, 113)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(232, 222, 248)",
				onSecondaryContainer: "rgb(29, 25, 43)",
				tertiary: "rgb(125, 82, 96)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(255, 217, 227)",
				onTertiaryContainer: "rgb(49, 16, 29)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(255, 251, 255)",
				onBackground: "rgb(28, 27, 30)",
				surface: "rgb(255, 251, 255)",
				onSurface: "rgb(28, 27, 30)",
				surfaceVariant: "rgb(230, 224, 236)",
				onSurfaceVariant: "rgb(72, 69, 78)",
				outline: "rgb(121, 117, 127)",
				outlineVariant: "rgb(202, 196, 207)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(49, 48, 51)",
				inverseOnSurface: "rgb(244, 239, 244)",
				inversePrimary: "rgb(206, 189, 255)",
				elevation: {
					level0: "transparent",
					level1: "rgb(247, 242, 252)",
					level2: "rgb(243, 237, 250)",
					level3: "rgb(238, 231, 248)",
					level4: "rgb(237, 229, 247)",
					level5: "rgb(234, 226, 246)",
				},
				surfaceDisabled: "rgba(28, 27, 30, 0.12)",
				onSurfaceDisabled: "rgba(28, 27, 30, 0.38)",
				backdrop: "rgba(50, 47, 56, 0.4)",
			},
			dark: {
				primary: "rgb(206, 189, 255)",
				onPrimary: "rgb(57, 5, 144)",
				primaryContainer: "rgb(80, 43, 167)",
				onPrimaryContainer: "rgb(232, 221, 255)",
				secondary: "rgb(203, 195, 220)",
				onSecondary: "rgb(51, 45, 65)",
				secondaryContainer: "rgb(73, 68, 88)",
				onSecondaryContainer: "rgb(232, 222, 248)",
				tertiary: "rgb(239, 184, 201)",
				onTertiary: "rgb(73, 37, 50)",
				tertiaryContainer: "rgb(99, 59, 73)",
				onTertiaryContainer: "rgb(255, 217, 227)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(28, 27, 30)",
				onBackground: "rgb(230, 225, 230)",
				surface: "rgb(28, 27, 30)",
				onSurface: "rgb(230, 225, 230)",
				surfaceVariant: "rgb(72, 69, 78)",
				onSurfaceVariant: "rgb(202, 196, 207)",
				outline: "rgb(148, 143, 153)",
				outlineVariant: "rgb(72, 69, 78)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(230, 225, 230)",
				inverseOnSurface: "rgb(49, 48, 51)",
				inversePrimary: "rgb(104, 71, 192)",
				elevation: {
					level0: "transparent",
					level1: "rgb(37, 35, 41)",
					level2: "rgb(42, 40, 48)",
					level3: "rgb(48, 45, 55)",
					level4: "rgb(49, 46, 57)",
					level5: "rgb(53, 50, 62)",
				},
				surfaceDisabled: "rgba(230, 225, 230, 0.12)",
				onSurfaceDisabled: "rgba(230, 225, 230, 0.38)",
				backdrop: "rgba(50, 47, 56, 0.4)",
			},
		},
	},
	"construction-1": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(121, 89, 0)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(255, 223, 160)",
				onPrimaryContainer: "rgb(38, 26, 0)",
				secondary: "rgb(107, 92, 63)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(245, 224, 187)",
				onSecondaryContainer: "rgb(36, 26, 4)",
				tertiary: "rgb(74, 101, 70)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(204, 235, 196)",
				onTertiaryContainer: "rgb(8, 32, 8)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(255, 251, 255)",
				onBackground: "rgb(30, 27, 22)",
				surface: "rgb(255, 251, 255)",
				onSurface: "rgb(30, 27, 22)",
				surfaceVariant: "rgb(237, 225, 207)",
				onSurfaceVariant: "rgb(77, 70, 57)",
				outline: "rgb(127, 118, 103)",
				outlineVariant: "rgb(208, 197, 180)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(52, 48, 42)",
				inverseOnSurface: "rgb(248, 239, 231)",
				inversePrimary: "rgb(248, 189, 42)",
				elevation: {
					level0: "transparent",
					level1: "rgb(248, 243, 242)",
					level2: "rgb(244, 238, 235)",
					level3: "rgb(240, 233, 227)",
					level4: "rgb(239, 232, 224)",
					level5: "rgb(236, 228, 219)",
				},
				surfaceDisabled: "rgba(30, 27, 22, 0.12)",
				onSurfaceDisabled: "rgba(30, 27, 22, 0.38)",
				backdrop: "rgba(54, 48, 36, 0.4)",
			},
			dark: {
				primary: "rgb(248, 189, 42)",
				onPrimary: "rgb(64, 45, 0)",
				primaryContainer: "rgb(92, 67, 0)",
				onPrimaryContainer: "rgb(255, 223, 160)",
				secondary: "rgb(216, 196, 160)",
				onSecondary: "rgb(59, 47, 21)",
				secondaryContainer: "rgb(83, 69, 42)",
				onSecondaryContainer: "rgb(245, 224, 187)",
				tertiary: "rgb(177, 207, 169)",
				onTertiary: "rgb(29, 54, 27)",
				tertiaryContainer: "rgb(51, 77, 48)",
				onTertiaryContainer: "rgb(204, 235, 196)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(30, 27, 22)",
				onBackground: "rgb(233, 225, 216)",
				surface: "rgb(30, 27, 22)",
				onSurface: "rgb(233, 225, 216)",
				surfaceVariant: "rgb(77, 70, 57)",
				onSurfaceVariant: "rgb(208, 197, 180)",
				outline: "rgb(153, 143, 128)",
				outlineVariant: "rgb(77, 70, 57)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(233, 225, 216)",
				inverseOnSurface: "rgb(52, 48, 42)",
				inversePrimary: "rgb(121, 89, 0)",
				elevation: {
					level0: "transparent",
					level1: "rgb(41, 35, 23)",
					level2: "rgb(47, 40, 24)",
					level3: "rgb(54, 45, 24)",
					level4: "rgb(56, 46, 24)",
					level5: "rgb(61, 50, 25)",
				},
				surfaceDisabled: "rgba(233, 225, 216, 0.12)",
				onSurfaceDisabled: "rgba(233, 225, 216, 0.38)",
				backdrop: "rgba(54, 48, 36, 0.4)",
			},
		},
	},
	"finance-1": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(16, 109, 32)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(157, 248, 152)",
				onPrimaryContainer: "rgb(0, 34, 4)",
				secondary: "rgb(82, 99, 79)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(213, 232, 206)",
				onSecondaryContainer: "rgb(17, 31, 15)",
				tertiary: "rgb(56, 101, 106)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(188, 235, 240)",
				onTertiaryContainer: "rgb(0, 32, 35)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(252, 253, 246)",
				onBackground: "rgb(26, 28, 25)",
				surface: "rgb(252, 253, 246)",
				onSurface: "rgb(26, 28, 25)",
				surfaceVariant: "rgb(222, 229, 216)",
				onSurfaceVariant: "rgb(66, 73, 64)",
				outline: "rgb(114, 121, 111)",
				outlineVariant: "rgb(194, 201, 189)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(47, 49, 45)",
				inverseOnSurface: "rgb(240, 241, 235)",
				inversePrimary: "rgb(130, 219, 126)",
				elevation: {
					level0: "transparent",
					level1: "rgb(240, 246, 235)",
					level2: "rgb(233, 242, 229)",
					level3: "rgb(226, 237, 223)",
					level4: "rgb(224, 236, 220)",
					level5: "rgb(219, 233, 216)",
				},
				surfaceDisabled: "rgba(26, 28, 25, 0.12)",
				onSurfaceDisabled: "rgba(26, 28, 25, 0.38)",
				backdrop: "rgba(44, 50, 42, 0.4)",
			},
			dark: {
				primary: "rgb(130, 219, 126)",
				onPrimary: "rgb(0, 57, 10)",
				primaryContainer: "rgb(0, 83, 18)",
				onPrimaryContainer: "rgb(157, 248, 152)",
				secondary: "rgb(186, 204, 179)",
				onSecondary: "rgb(37, 52, 35)",
				secondaryContainer: "rgb(59, 75, 56)",
				onSecondaryContainer: "rgb(213, 232, 206)",
				tertiary: "rgb(160, 207, 212)",
				onTertiary: "rgb(0, 54, 59)",
				tertiaryContainer: "rgb(31, 77, 82)",
				onTertiaryContainer: "rgb(188, 235, 240)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(26, 28, 25)",
				onBackground: "rgb(226, 227, 221)",
				surface: "rgb(26, 28, 25)",
				onSurface: "rgb(226, 227, 221)",
				surfaceVariant: "rgb(66, 73, 64)",
				onSurfaceVariant: "rgb(194, 201, 189)",
				outline: "rgb(140, 147, 136)",
				outlineVariant: "rgb(66, 73, 64)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(226, 227, 221)",
				inverseOnSurface: "rgb(47, 49, 45)",
				inversePrimary: "rgb(16, 109, 32)",
				elevation: {
					level0: "transparent",
					level1: "rgb(31, 38, 30)",
					level2: "rgb(34, 43, 33)",
					level3: "rgb(37, 49, 36)",
					level4: "rgb(39, 51, 37)",
					level5: "rgb(41, 55, 39)",
				},
				surfaceDisabled: "rgba(226, 227, 221, 0.12)",
				onSurfaceDisabled: "rgba(226, 227, 221, 0.38)",
				backdrop: "rgba(44, 50, 42, 0.4)",
			},
		},
	},
	"officesync-1": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(67, 94, 189)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(220, 224, 255)",
				onPrimaryContainer: "rgb(0, 21, 84)",
				secondary: "rgb(85, 93, 157)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(223, 224, 255)",
				onSecondaryContainer: "rgb(16, 27, 66)",
				tertiary: "rgb(122, 82, 144)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(247, 216, 255)",
				onTertiaryContainer: "rgb(44, 18, 64)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(253, 251, 255)",
				onBackground: "rgb(28, 28, 31)",
				surface: "rgb(253, 251, 255)",
				onSurface: "rgb(28, 28, 31)",
				surfaceVariant: "rgb(227, 225, 236)",
				onSurfaceVariant: "rgb(70, 70, 79)",
				outline: "rgb(119, 118, 128)",
				outlineVariant: "rgb(199, 197, 208)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(48, 48, 52)",
				inverseOnSurface: "rgb(243, 240, 244)",
				inversePrimary: "rgb(184, 194, 255)",
				elevation: {
					level0: "transparent",
					level1: "rgb(245, 242, 250)",
					level2: "rgb(240, 237, 247)",
					level3: "rgb(235, 231, 244)",
					level4: "rgb(233, 229, 243)",
					level5: "rgb(230, 225, 241)",
				},
				surfaceDisabled: "rgba(28, 28, 31, 0.12)",
				onSurfaceDisabled: "rgba(28, 28, 31, 0.38)",
				backdrop: "rgba(49, 48, 58, 0.4)",
			},
			dark: {
				primary: "rgb(184, 194, 255)",
				onPrimary: "rgb(11, 40, 120)",
				primaryContainer: "rgb(43, 67, 153)",
				onPrimaryContainer: "rgb(220, 224, 255)",
				secondary: "rgb(194, 196, 246)",
				onSecondary: "rgb(37, 48, 89)",
				secondaryContainer: "rgb(60, 70, 113)",
				onSecondaryContainer: "rgb(223, 224, 255)",
				tertiary: "rgb(220, 184, 246)",
				onTertiary: "rgb(67, 39, 87)",
				tertiaryContainer: "rgb(93, 61, 115)",
				onTertiaryContainer: "rgb(247, 216, 255)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(28, 28, 31)",
				onBackground: "rgb(229, 227, 230)",
				surface: "rgb(28, 28, 31)",
				onSurface: "rgb(229, 227, 230)",
				surfaceVariant: "rgb(70, 70, 79)",
				onSurfaceVariant: "rgb(199, 197, 208)",
				outline: "rgb(145, 143, 154)",
				outlineVariant: "rgb(70, 70, 79)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(229, 227, 230)",
				inverseOnSurface: "rgb(48, 48, 52)",
				inversePrimary: "rgb(67, 94, 189)",
				elevation: {
					level0: "transparent",
					level1: "rgb(36, 36, 42)",
					level2: "rgb(40, 41, 49)",
					level3: "rgb(45, 46, 56)",
					level4: "rgb(47, 47, 58)",
					level5: "rgb(50, 51, 62)",
				},
				surfaceDisabled: "rgba(229, 227, 230, 0.12)",
				onSurfaceDisabled: "rgba(229, 227, 230, 0.38)",
				backdrop: "rgba(49, 48, 58, 0.4)",
			},
		},
	},
	"techcore-1": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(0, 135, 111)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(146, 251, 230)",
				onPrimaryContainer: "rgb(0, 41, 33)",
				secondary: "rgb(74, 99, 94)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(205, 232, 226)",
				onSecondaryContainer: "rgb(7, 31, 27)",
				tertiary: "rgb(59, 107, 135)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(190, 229, 255)",
				onTertiaryContainer: "rgb(0, 32, 47)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(249, 253, 251)",
				onBackground: "rgb(25, 29, 28)",
				surface: "rgb(249, 253, 251)",
				onSurface: "rgb(25, 29, 28)",
				surfaceVariant: "rgb(218, 229, 225)",
				onSurfaceVariant: "rgb(64, 73, 71)",
				outline: "rgb(112, 121, 119)",
				outlineVariant: "rgb(190, 201, 197)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(45, 49, 48)",
				inverseOnSurface: "rgb(239, 241, 239)",
				inversePrimary: "rgb(117, 222, 202)",
				elevation: {
					level0: "transparent",
					level1: "rgb(239, 247, 244)",
					level2: "rgb(233, 243, 240)",
					level3: "rgb(227, 239, 236)",
					level4: "rgb(225, 238, 235)",
					level5: "rgb(221, 235, 231)",
				},
				surfaceDisabled: "rgba(25, 29, 28, 0.12)",
				onSurfaceDisabled: "rgba(25, 29, 28, 0.38)",
				backdrop: "rgba(42, 51, 49, 0.4)",
			},
			dark: {
				primary: "rgb(117, 222, 202)",
				onPrimary: "rgb(0, 66, 54)",
				primaryContainer: "rgb(0, 96, 79)",
				onPrimaryContainer: "rgb(146, 251, 230)",
				secondary: "rgb(177, 203, 198)",
				onSecondary: "rgb(28, 52, 48)",
				secondaryContainer: "rgb(51, 75, 70)",
				onSecondaryContainer: "rgb(205, 232, 226)",
				tertiary: "rgb(146, 198, 230)",
				onTertiary: "rgb(11, 55, 75)",
				tertiaryContainer: "rgb(36, 78, 100)",
				onTertiaryContainer: "rgb(190, 229, 255)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(25, 29, 28)",
				onBackground: "rgb(225, 227, 225)",
				surface: "rgb(25, 29, 28)",
				onSurface: "rgb(225, 227, 225)",
				surfaceVariant: "rgb(64, 73, 71)",
				onSurfaceVariant: "rgb(190, 201, 197)",
				outline: "rgb(138, 147, 144)",
				outlineVariant: "rgb(64, 73, 71)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(225, 227, 225)",
				inverseOnSurface: "rgb(45, 49, 48)",
				inversePrimary: "rgb(0, 135, 111)",
				elevation: {
					level0: "transparent",
					level1: "rgb(29, 38, 36)",
					level2: "rgb(31, 43, 41)",
					level3: "rgb(33, 49, 46)",
					level4: "rgb(34, 51, 48)",
					level5: "rgb(35, 55, 51)",
				},
				surfaceDisabled: "rgba(225, 227, 225, 0.12)",
				onSurfaceDisabled: "rgba(225, 227, 225, 0.38)",
				backdrop: "rgba(42, 51, 49, 0.4)",
			},
		},
	},
	"mediquest-1": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(0, 51, 102)", // NBME blue
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(204, 229, 255)",
				onPrimaryContainer: "rgb(0, 25, 51)",
				secondary: "rgb(0, 102, 153)", // NBME secondary blue
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(204, 229, 255)",
				onSecondaryContainer: "rgb(0, 51, 77)",
				tertiary: "rgb(153, 0, 0)", // NBME red
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(255, 204, 204)",
				onTertiaryContainer: "rgb(51, 0, 0)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(255, 255, 255)",
				onBackground: "rgb(0, 0, 0)",
				surface: "rgb(255, 255, 255)",
				onSurface: "rgb(0, 0, 0)",
				surfaceVariant: "rgb(240, 240, 240)",
				onSurfaceVariant: "rgb(51, 51, 51)",
				outline: "rgb(102, 102, 102)",
				outlineVariant: "rgb(204, 204, 204)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(51, 51, 51)",
				inverseOnSurface: "rgb(255, 255, 255)",
				inversePrimary: "rgb(153, 204, 255)",
				elevation: {
					level0: "transparent",
					level1: "rgb(245, 245, 245)",
					level2: "rgb(240, 240, 240)",
					level3: "rgb(235, 235, 235)",
					level4: "rgb(230, 230, 230)",
					level5: "rgb(225, 225, 225)",
				},
				surfaceDisabled: "rgba(0, 0, 0, 0.12)",
				onSurfaceDisabled: "rgba(0, 0, 0, 0.38)",
				backdrop: "rgba(0, 0, 0, 0.4)",
			},
			dark: {
				primary: "rgb(51, 153, 255)", // Lighter NBME blue
				onPrimary: "rgb(0, 25, 51)",
				primaryContainer: "rgb(0, 51, 102)",
				onPrimaryContainer: "rgb(204, 229, 255)",
				secondary: "rgb(51, 204, 255)", // Lighter NBME secondary blue
				onSecondary: "rgb(0, 25, 51)",
				secondaryContainer: "rgb(0, 51, 102)",
				onSecondaryContainer: "rgb(204, 229, 255)",
				tertiary: "rgb(255, 51, 51)", // Lighter NBME red
				onTertiary: "rgb(51, 0, 0)",
				tertiaryContainer: "rgb(102, 0, 0)",
				onTertiaryContainer: "rgb(255, 204, 204)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(0, 0, 0)",
				onBackground: "rgb(255, 255, 255)",
				surface: "rgb(0, 0, 0)",
				onSurface: "rgb(255, 255, 255)",
				surfaceVariant: "rgb(51, 51, 51)",
				onSurfaceVariant: "rgb(204, 204, 204)",
				outline: "rgb(153, 153, 153)",
				outlineVariant: "rgb(51, 51, 51)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(255, 255, 255)",
				inverseOnSurface: "rgb(0, 0, 0)",
				inversePrimary: "rgb(0, 51, 102)",
				elevation: {
					level0: "transparent",
					level1: "rgb(25, 25, 25)",
					level2: "rgb(30, 30, 30)",
					level3: "rgb(35, 35, 35)",
					level4: "rgb(40, 40, 40)",
					level5: "rgb(45, 45, 45)",
				},
				surfaceDisabled: "rgba(255, 255, 255, 0.12)",
				onSurfaceDisabled: "rgba(255, 255, 255, 0.38)",
				backdrop: "rgba(0, 0, 0, 0.4)",
			},
		},
	},
	"aswb-1": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(56, 91, 171)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(218, 226, 255)",
				onPrimaryContainer: "rgb(0, 24, 71)",
				secondary: "rgb(0, 104, 116)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(151, 240, 255)",
				onSecondaryContainer: "rgb(0, 31, 36)",
				tertiary: "rgb(115, 84, 114)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(254, 215, 249)",
				onTertiaryContainer: "rgb(43, 18, 44)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(254, 251, 255)",
				onBackground: "rgb(27, 27, 31)",
				surface: "rgb(254, 251, 255)",
				onSurface: "rgb(27, 27, 31)",
				surfaceVariant: "rgb(225, 226, 236)",
				onSurfaceVariant: "rgb(68, 70, 79)",
				outline: "rgb(117, 119, 128)",
				outlineVariant: "rgb(197, 198, 208)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(48, 48, 52)",
				inverseOnSurface: "rgb(242, 240, 244)",
				inversePrimary: "rgb(177, 197, 255)",
				elevation: {
					level0: "transparent",
					level1: "rgb(244, 243, 251)",
					level2: "rgb(238, 238, 248)",
					level3: "rgb(232, 233, 246)",
					level4: "rgb(230, 232, 245)",
					level5: "rgb(226, 229, 243)",
				},
				surfaceDisabled: "rgba(27, 27, 31, 0.12)",
				onSurfaceDisabled: "rgba(27, 27, 31, 0.38)",
				backdrop: "rgba(46, 48, 56, 0.4)",
			},
			dark: {
				primary: "rgb(177, 197, 255)",
				onPrimary: "rgb(0, 44, 114)",
				primaryContainer: "rgb(27, 66, 145)",
				onPrimaryContainer: "rgb(218, 226, 255)",
				secondary: "rgb(79, 216, 235)",
				onSecondary: "rgb(0, 54, 61)",
				secondaryContainer: "rgb(0, 79, 88)",
				onSecondaryContainer: "rgb(151, 240, 255)",
				tertiary: "rgb(225, 187, 221)",
				onTertiary: "rgb(65, 39, 66)",
				tertiaryContainer: "rgb(90, 61, 89)",
				onTertiaryContainer: "rgb(254, 215, 249)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(27, 27, 31)",
				onBackground: "rgb(228, 226, 230)",
				surface: "rgb(27, 27, 31)",
				onSurface: "rgb(228, 226, 230)",
				surfaceVariant: "rgb(68, 70, 79)",
				onSurfaceVariant: "rgb(197, 198, 208)",
				outline: "rgb(143, 144, 153)",
				outlineVariant: "rgb(68, 70, 79)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(228, 226, 230)",
				inverseOnSurface: "rgb(48, 48, 52)",
				inversePrimary: "rgb(56, 91, 171)",
				elevation: {
					level0: "transparent",
					level1: "rgb(35, 36, 42)",
					level2: "rgb(39, 41, 49)",
					level3: "rgb(44, 46, 56)",
					level4: "rgb(45, 47, 58)",
					level5: "rgb(48, 51, 62)",
				},
				surfaceDisabled: "rgba(228, 226, 230, 0.12)",
				onSurfaceDisabled: "rgba(228, 226, 230, 0.38)",
				backdrop: "rgba(46, 48, 56, 0.4)",
			},
		},
	},
	"aswb-supervision-certification": {
		roundness: 2,
		colors: {
			light: {
				primary: "rgb(56, 91, 171)",
				onPrimary: "rgb(255, 255, 255)",
				primaryContainer: "rgb(218, 226, 255)",
				onPrimaryContainer: "rgb(0, 24, 71)",
				secondary: "rgb(0, 104, 116)",
				onSecondary: "rgb(255, 255, 255)",
				secondaryContainer: "rgb(151, 240, 255)",
				onSecondaryContainer: "rgb(0, 31, 36)",
				tertiary: "rgb(115, 84, 114)",
				onTertiary: "rgb(255, 255, 255)",
				tertiaryContainer: "rgb(254, 215, 249)",
				onTertiaryContainer: "rgb(43, 18, 44)",
				error: "rgb(186, 26, 26)",
				onError: "rgb(255, 255, 255)",
				errorContainer: "rgb(255, 218, 214)",
				onErrorContainer: "rgb(65, 0, 2)",
				background: "rgb(254, 251, 255)",
				onBackground: "rgb(27, 27, 31)",
				surface: "rgb(254, 251, 255)",
				onSurface: "rgb(27, 27, 31)",
				surfaceVariant: "rgb(225, 226, 236)",
				onSurfaceVariant: "rgb(68, 70, 79)",
				outline: "rgb(117, 119, 128)",
				outlineVariant: "rgb(197, 198, 208)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(48, 48, 52)",
				inverseOnSurface: "rgb(242, 240, 244)",
				inversePrimary: "rgb(177, 197, 255)",
				elevation: {
					level0: "transparent",
					level1: "rgb(244, 243, 251)",
					level2: "rgb(238, 238, 248)",
					level3: "rgb(232, 233, 246)",
					level4: "rgb(230, 232, 245)",
					level5: "rgb(226, 229, 243)",
				},
				surfaceDisabled: "rgba(27, 27, 31, 0.12)",
				onSurfaceDisabled: "rgba(27, 27, 31, 0.38)",
				backdrop: "rgba(46, 48, 56, 0.4)",
			},
			dark: {
				primary: "rgb(177, 197, 255)",
				onPrimary: "rgb(0, 44, 114)",
				primaryContainer: "rgb(27, 66, 145)",
				onPrimaryContainer: "rgb(218, 226, 255)",
				secondary: "rgb(79, 216, 235)",
				onSecondary: "rgb(0, 54, 61)",
				secondaryContainer: "rgb(0, 79, 88)",
				onSecondaryContainer: "rgb(151, 240, 255)",
				tertiary: "rgb(225, 187, 221)",
				onTertiary: "rgb(65, 39, 66)",
				tertiaryContainer: "rgb(90, 61, 89)",
				onTertiaryContainer: "rgb(254, 215, 249)",
				error: "rgb(255, 180, 171)",
				onError: "rgb(105, 0, 5)",
				errorContainer: "rgb(147, 0, 10)",
				onErrorContainer: "rgb(255, 180, 171)",
				background: "rgb(27, 27, 31)",
				onBackground: "rgb(228, 226, 230)",
				surface: "rgb(27, 27, 31)",
				onSurface: "rgb(228, 226, 230)",
				surfaceVariant: "rgb(68, 70, 79)",
				onSurfaceVariant: "rgb(197, 198, 208)",
				outline: "rgb(143, 144, 153)",
				outlineVariant: "rgb(68, 70, 79)",
				shadow: "rgb(0, 0, 0)",
				scrim: "rgb(0, 0, 0)",
				inverseSurface: "rgb(228, 226, 230)",
				inverseOnSurface: "rgb(48, 48, 52)",
				inversePrimary: "rgb(56, 91, 171)",
				elevation: {
					level0: "transparent",
					level1: "rgb(35, 36, 42)",
					level2: "rgb(39, 41, 49)",
					level3: "rgb(44, 46, 56)",
					level4: "rgb(45, 47, 58)",
					level5: "rgb(48, 51, 62)",
				},
				surfaceDisabled: "rgba(228, 226, 230, 0.12)",
				onSurfaceDisabled: "rgba(228, 226, 230, 0.38)",
				backdrop: "rgba(46, 48, 56, 0.4)",
			},
		},
	},
};
